import { AsyncPipe, NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, TemplateRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';
import { BehaviorSubject } from 'rxjs';

import {
  RouteTabGroupComponent,
  TabGroupConfig,
} from '@features/tab-group/route-tab-group.component';

import { ROUTING_PATH } from '@shared/constants/routingPath';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgTemplateOutlet, RouteTabGroupComponent, RouterOutlet, AsyncPipe],
  selector: 'aux-ops-admin',
  templateUrl: './ops-admin.component.html',
})
export class OpsAdminComponent {
  private route = inject(ActivatedRoute);
  private router = inject(Router);

  activeTabIndex$ = new BehaviorSubject<number>(0);
  rightSideContainer = new BehaviorSubject<null | TemplateRef<unknown>>(null);
  tabs: TabGroupConfig[] = [
    {
      label: 'EDC Converter',
      route: ROUTING_PATH.OPS_ADMIN.EDC_CONVERTER.INDEX,
    },
    {
      label: 'JE Generator',
      route: ROUTING_PATH.OPS_ADMIN.JE_GENERATOR,
    },
    {
      label: 'Extractor',
      route: ROUTING_PATH.OPS_ADMIN.EXTRACTOR,
    },
    {
      label: 'Site Payments: Invoice Generator',
      route: ROUTING_PATH.OPS_ADMIN.INVOICE_GENERATOR,
    },
  ];

  constructor() {
    this.route.queryParams.pipe(takeUntilDestroyed()).subscribe((params) => {
      if (params.activeTabIndex) {
        this.activeTabIndex$.next(parseInt(params.activeTabIndex, 10));
        void this.router.navigate([], { queryParams: {}, replaceUrl: true });
      }
    });
  }
}
